import React, { useEffect, useState } from "react";
import { OnboardingButton } from "../../../components/onboarding/OnboardingButton";
import "../Css/custom-new.css";
import OnboardingInput from "../../../components/onboarding/OnboardingInput";
import { fetchAPI } from "../../../utils/fetch";
import { config } from "../../../utils/config";
import OnboardingSelect from "../../../components/onboarding/OnboardingSelect";
import OnboardingCheckbox from "../../../components/onboarding/OnboardingCheckbox";

const Step3 = ({
  setProgress,
  setStep,
  onboardingData,
  setOnboardingData,
  toneData,
  stepInfo,
  setStepInfo,
  ctaOptions,
  engagementPreferencesOptions
}) => {
  const [formData, setFormData] = useState(onboardingData);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(onboardingData.engagementPreferences || []);
  const [isFirstTime, setIsFirstTime] = useState(true);

  useEffect(() => {
    setIsFirstTime(!onboardingData.tone);
    setProgress(70);
  }, []);

  const isOtherSelected = formData.tone === "Other" || !toneData.includes(formData.tone);

  const updateAPI = async (step, field, value) => {
    try {
      setStepInfo({ step, message: `Updating ${field}...` });
      const response = await fetchAPI.post(
        `${config.urlPlatform}/api/v2/onboarding/add`,
        { withCredentials: true },
        { step, field, value }
      );

      if (response?.data?.success) {
        const updatedData = { ...formData, [field]: value };
        setFormData(updatedData);
        setOnboardingData(updatedData);
        setError(null);
      } else {
        setError(response?.data?.message || "Update failed.");
      }
    } catch (err) {
      setError("Failed to update. Please try again.");
    } finally {
      setStepInfo({ step: -1, message: null });
    }
  };

  const handleCTAChange = (value) => {
    updateAPI(4, "callToAction", value);
  };

  const handleEngagementChange = (newSelection) => {
    setSelected(newSelection);
    updateAPI(5, "engagementPreferences", newSelection);
  };

  const handleNext = () => {
    setError(null);
    setStep(4);
  };

  return (
    <div className="onboarding-body-global">
      {/* STEP 6 */}
      <div className="step0-onboarding-heading">AI can add questions like 'What do you think?' or keep it neutral.</div>
      <div className="onboarding-Wrapper-container" style={{ width: "90%", display: "flex", flexDirection: "column", gap: "20px" }}>
        <OnboardingSelect
          label="You want questions?"
          options={ctaOptions}
          selectedValue={formData.callToAction}
          onChange={handleCTAChange}
        />
        {stepInfo.step === 4 && stepInfo.message && (
          <div className="info-message-onboarding">{stepInfo.message}</div>
        )}
        {error && <div className="error-message-onboarding">{error}</div>}
      </div>

      {/* STEP 7 */}
      <div className="onboarding-body-global" style={{ gap: "20px", paddingTop: "50px" }}>
        <div className="step0-onboarding-heading">What kind of posts do you usually comment on?</div>
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>
          <OnboardingCheckbox
            options={engagementPreferencesOptions}
            selectedOptions={selected}
            onChange={handleEngagementChange}
          />
          {stepInfo.step === 5 && stepInfo.message && (
            <div className="info-message-onboarding">{stepInfo.message}</div>
          )}
          {error && <div className="error-message-onboarding">{error}</div>}
          <div className="onboarding-below-buttons">
            <OnboardingButton
              style={{ width: "177px", height: "55px" }}
              onClick={() => setStep(2)}
              title="Back"
            />
            <OnboardingButton
              style={{ width: "177px", height: "55px" }}
              onClick={handleNext}
              title="Next"
              variant="hollow"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step3;
